import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { socioApi, type OnchainEvent, ApiError } from "@/api/client";
import { AppShell } from "@/components/AppShell";
import { OnchainActivity } from "@/components/OnchainActivity";

/** Histórico on-chain das transações que envolvem a wallet do sócio. */
export default function Activity() {
  const [events, setEvents] = useState<OnchainEvent[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    socioApi.activity()
      .then((r) => setEvents(r.events))
      .catch((err) => setError(err instanceof ApiError ? err.message : err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AppShell>
      <div className="max-w-5xl mx-auto p-6">
        <Link to="/dashboard" className="text-sm underline text-app-muted hover:text-app-accent">
          ← dashboard
        </Link>
        <h1 className="text-2xl font-bold my-4">Minha atividade on-chain</h1>
        <p className="text-sm text-app-muted mb-4">
          Tudo que tocou sua carteira na rede — transferências, vestings e saques —
          com link pra conferir no Basescan.
        </p>

        {loading && <p className="text-sm text-app-muted">Carregando...</p>}
        {error && <div className="bg-red-500/10 border border-red-500/40 rounded p-3 text-sm text-red-500 mb-3">{error}</div>}
        {!loading && !error && (
          <OnchainActivity events={events}
            emptyHint="Você ainda não tem transações on-chain. Quando receber ou sacar tokens, aparece aqui." />
        )}
      </div>
    </AppShell>
  );
}
